<template>
	<div class="tcp-page tcp-ritual">
		<div v-if="missing" class="tcp-ritual__missing">
			<i class="fa fa-book"></i>
			<h1>Ritual not found</h1>
			<p>This article may have moved or is not published yet.</p>
			<router-link to="/rituals" class="tcp-btn tcp-btn--outline"><i class="fa fa-arrow-left"></i> Back to Rituals</router-link>
		</div>

		<template v-else-if="row">
			<div class="tcp-ritual__hero">
				<img v-if="row.image_url" :src="row.image_url" :alt="row.title">
				<router-link to="/rituals" class="tcp-ritual__back"><i class="fa fa-arrow-left"></i> Rituals</router-link>
			</div>

			<article class="tcp-ritual__article">
				<div class="tcp-rituals__meta">
					<span v-if="row.category" class="tcp-rituals__pill tcp-rituals__pill--solid">{{ row.category }}</span>
					<span v-if="row.read_time"><i class="fa fa-clock-o"></i> {{ row.read_time }}</span>
					<span v-if="row.date">{{ row.date }}</span>
				</div>
				<h1>{{ row.title }}</h1>
				<div v-if="row.author" class="tcp-ritual__author">
					<span class="tcp-ritual__avatar"><i class="fa fa-user"></i></span>
					<p>{{ row.author }}</p>
				</div>
				<div v-if="row.body" class="tcp-ritual__body" v-html="row.body"></div>
				<p v-else-if="row.excerpt" class="tcp-ritual__body">{{ row.excerpt }}</p>

				<div v-if="row.related && row.related.length" class="tcp-ritual__related">
					<h2>Continue Reading</h2>
					<div class="tcp-ritual__related-grid">
						<router-link v-for="item in row.related" :key="item.id" :to="'/rituals/' + item.id">
							<div class="tcp-ritual__related-media">
								<img v-if="item.image_url" :src="item.image_url" :alt="item.title">
							</div>
							<div>
								<span v-if="item.category" class="tcp-rituals__pill">{{ item.category }}</span>
								<p>{{ item.title }}</p>
								<small v-if="item.read_time"><i class="fa fa-clock-o"></i> {{ item.read_time }}</small>
							</div>
						</router-link>
					</div>
				</div>
			</article>
		</template>
	</div>
</template>

<script>
export default {
	data() {
		return {
			row: null,
			missing: false
		}
	},
	watch: {
		'$route.params.id': 'load'
	},
	mounted() {
		this.load()
	},
	methods: {
		load() {
			this.row = null
			this.missing = false
			axios.get(tools.url('/api/store/rituals/' + this.$route.params.id)).then((response) => {
				this.row = response.data
				if (this.row && this.row.title) {
					document.title = this.row.title + ' - The Conscious Pantry'
				}
			}).catch(() => {
				this.missing = true
			})
		}
	}
}
</script>
